<template>
  <ctaWrapper
    :iconsColor="theme.icons"
    :textColor="theme.text"
    :button="theme.button"
    :backgroundColor="theme.background"
    class="module module-cta-with-form padding_large"
    v-observe-visibility="visibilityChanged"
    :class="[
      { 'show-up': isVisible, 'fix-transfrom': fixTransfrom },
      baseAnimation,
      moduleClass,
      'theme-' + data.theme,
      'text-' + currentTheme().text_color
    ]"
  >
    <ModuleContainer>
      <div class="inner-module">
        <ModuleHeading class="text-center">{{ data.title }}</ModuleHeading>
        <DynamicHtml class="description text-center" :html="data.description" />
        <div class="btn-holder text-center">
          <a
            v-if="isLink && data.button_name && data.button_link"
            :href="data.button_link"
            @click="followLink"
            class="btn btn-primary"
          >
            <span>{{ data.button_name }}</span>
            <span class="icon-right" v-html="svgIcons.arrow"></span>
          </a>
          <button
            @click="triggerGFPopup"
            :aria-label="data.button_name"
            v-else-if="!isLink && data.button_name"
            class="btn btn-primary"
          >
            <span>{{ data.button_name }}</span>
            <span class="icon-right" v-html="svgIcons.arrow"></span>
          </button>
        </div>
      </div>

      <div class="GF-popup" v-if="!isLink" v-show="showForm">
        <div class="clickoverlay" @click="togglePopup"></div>
        <div class="inner-cta">
          <div class="heading-form">
            <WpImage :data="logoTopDark" class="logo-popup" />
            <svg
              @click="togglePopup"
              class="close-icon"
              width="19px"
              height="19px"
              viewBox="0 0 19 19"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <path
                  d="M0.596919918,0.596919918 C1.39281314,-0.198973306 2.68809035,-0.198973306 3.48398357,0.596919918 L3.48398357,0.596919918 L9.5,6.61293634 L15.5160164,0.596919918 C16.3119097,-0.198973306 17.6071869,-0.198973306 18.4030801,0.596919918 C19.1989733,1.39281314 19.1989733,2.68809035 18.4030801,3.48398357 L18.4030801,3.48398357 L12.387,9.5 L18.4030801,15.5160164 C19.1570842,16.2700205 19.1967686,17.4722252 18.5221334,18.2734083 L18.4030801,18.4030801 C17.6071869,19.1989733 16.3119097,19.1989733 15.5160164,18.4030801 L15.5160164,18.4030801 L9.5,12.3870637 L3.48398357,18.4030801 C2.68809035,19.1989733 1.39281314,19.1989733 0.596919918,18.4030801 C-0.198973306,17.6071869 -0.198973306,16.3119097 0.596919918,15.5160164 L0.596919918,15.5160164 L6.613,9.5 L0.596919918,3.48398357 C-0.157084189,2.72997947 -0.196768616,1.52777478 0.477866638,0.72659166 Z"
                  id="path-2323"
                ></path>
              </defs>
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g>
                  <g id="close">
                    <g>
                      <mask id="mask-2323" fill="white">
                        <use xlink:href="#path-2323"></use>
                      </mask>
                      <use
                        id="Mask232"
                        fill="#41454B"
                        xlink:href="#path-2323"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <h3 class="popup-title">
            {{ data.popup_tite }}
          </h3>
          <DynamicHtml :html="data.popup_text" />
          <DynamicHtml :html="testHtml" />
        </div>
      </div>
    </ModuleContainer>
  </ctaWrapper>
</template>

<script>
import styled from "vue-styled-components";
import WpImage from "@/components/elements/WpImage";

const wrapperProps = {
  iconsColor: String,
  backgroundColor: String,
  textColor: String,
  button: String
};
const ctaWrapper = styled("section", wrapperProps)`
  ${props =>
    props.backgroundColor && props.backgroundColor !== ""
      ? "background-color: " + props.backgroundColor
      : ""};
  ${props =>
    props.textColor && props.textColor !== ""
      ? "color:" + props.textColor
      : ""};
  ${props =>
    props.iconsColor && props.iconsColor !== ""
      ? " .btn svg g{ fill: " + props.iconsColor + " !important}"
      : ""};

  ${props =>
    props.iconsColor && props.iconsColor !== ""
      ? " .btn{ color: " +
        props.backgroundColor +
        "; background-color: " +
        props.textColor +
        "!important}"
      : ""};
  ${props =>
    props.button && props.button !== ""
      ? " .btn{ color: " +
        props.iconsColor +
        "; background-color: " +
        props.button +
        "!important}"
      : ""};
`;

export default {
  name: "cta-with-form",
  props: ["data"],
  data() {
    return {
      showForm: false,
      fixTransfrom: false,
      logoTopDark: window.WPVUE.options.page_logo
    };
  },
  components: {
    ctaWrapper,
    WpImage
  },
  computed: {
    isLink() {
      return this.data.button_action === "link";
    },
    testHtml() {
      return `<div>
        <div id="gf_button_form_container_${this.data.form_id}"></div>
        <a  class="call-gf-form" style="display: none;" data-to="" data-form="${this.data.form_id}"></a>
    </div>`;
    },
    moduleClass() {
      let theme = "";
      if (this.data.theme === "gray") theme = "bg-gray";
      return theme;
    },
    theme() {
      if (this.data.theme === "accent") {
        return {
          background: this.currentTheme().select_color,
          text: this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34",
          icons: this.currentTheme().select_color,
          button: ""
        };
      } else {
        return {
          background: "",
          text: "",
          icons:
            this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34",
          button: this.currentTheme().select_color
        };
      }
    }
  },
  methods: {
    togglePopup() {
      $("html").toggleClass("scroll-block hide-side");
      this.showForm = !this.showForm;
    },

    triggerGFPopup() {
      const VM = this;
      VM.togglePopup();
    },

    followLink($event) {
      const url = new URL(this.data.button_link, window.location.href);
      if (url.origin !== window.location.origin) return;
      $event.preventDefault();

      if (url.pathname !== window.location.pathname) {
        this.$router.push(url.pathname + url.hash);
        return;
      }
      const el = url.hash && document.getElementById(url.hash.substring(1));
      if (el) {
        history.replaceState(null, "", url.hash);
        $("html, body").animate({ scrollTop: $(el).offset().top - 20 }, 450);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.module-cta-with-form {
  position: relative;
  z-index: 90;
  .logo-popup {
    margin: 0;
  }
  .close-icon {
    width: 15px;
    height: 15px;
  }
  .inner-module {
    max-width: 600px;
    margin: 0 auto;
    .description {
      margin-bottom: 30px;
      @include fluid-type(380px, 1400px, 16px, 20px);
    }
    .btn {
      @include fluid-type(380px, 1400px, 18px, 22px);
    }
    a.btn {
      display: inline-block;
      text-decoration: none;
    }
  }
  .GF-popup {
    .gform_heading {
      display: none !important;
    }
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    color: $fontColor !important;
    background-color: rgba(rgb(45, 44, 44), 0.9);
    .heading-form {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo-icons {
        width: 101px;
        height: 32px;
        @include mquery(767px) {
          width: 71px;
          height: 22px;
        }
      }
      .close-icon {
        height: 25px;
        width: 25px;
        cursor: pointer;
      }
    }
    .clickoverlay {
      position: fixed;
      z-index: 5;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      cursor: pointer;
    }
    .inner-cta {
      position: relative;
      z-index: 10;
      max-width: 700px;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      margin-top: 5vh;
      max-height: 90vh;
      margin-bottom: 5vh;
      overflow: auto;
      background: #fff;
      padding: 54px;
      @include mquery(1199px) {
        padding: 31px;
      }
      @include mquery(767px) {
        margin-top: 0;
        margin-bottom: 0;
        max-height: 100%;
        height: 100%;
        padding: 24px;
      }
    }
  }
}
</style>
